export default "__VITE_PUBLIC_ASSET__48967638__"